import { TZDate } from '@date-fns/tz';
import type { TTicketDetails } from '@daymade/api-contracts';
import { BUSINESS_TIME_ZONE } from '@daymade/common-lib/constants';
import { GameType } from '@daymade/common-lib/dbEnums';

export interface WeekMarker {
  /** The day of the week to show */
  dayNumber: number;
  /** The total earnings for this week */
  earnings: number;
  /** Whether the current date is after this week marker, so we should draw the highlight to the right of the marker */
  isMidweek?: boolean;
}

export function placeTicketsIntoWeekMarkers(
  startOfMonth: TZDate,
  bigRaffleTickets: TTicketDetails[],
  weekMarkers: WeekMarker[],
) {
  for (const bigRaffleTicket of bigRaffleTickets) {
    const ticketDate = new TZDate(
      bigRaffleTicket.ticket.createdAt,
      BUSINESS_TIME_ZONE,
    );
    if (
      ticketDate.getMonth() !== startOfMonth.getMonth() ||
      ticketDate.getFullYear() !== startOfMonth.getFullYear()
    ) {
      continue;
    }

    let markerForTicket: WeekMarker | undefined;
    for (const week of weekMarkers) {
      if (ticketDate.getDate() >= week.dayNumber) {
        markerForTicket = week;
      } else {
        break;
      }
    }

    if (markerForTicket) {
      for (const entry of bigRaffleTicket.entries) {
        if (entry.type === GameType.BIG_RAFFLE) {
          markerForTicket.earnings += entry.weight;
        }
      }
    }
  }
}
